(() => {
  document.addEventListener(
    'theme:cart:popdown',
    (event) => {
      const drawer = document.querySelector(
        '[data-drawer="drawer-cart"]'
      );

      // 如果 Drawer 没有启用，保留主题原来的顶部提示。
      if (!drawer) return;

      // 阻止 Pipeline 显示顶部 Added to cart 提示。
      event.stopImmediatePropagation();

      const openDrawer = () => {
        drawer.dispatchEvent(
          new CustomEvent('theme:drawer:open', {
            bubbles: false
          })
        );
      };

      // 等购物车数据更新完成，再打开 Drawer。
      document.addEventListener(
        'theme:cart:change',
        openDrawer,
        { once: true }
      );
    },
    true
  );
})();